import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'

import { editCompanyGeneral } from '../../actions'

import { Form, Input, Button } from 'antd'
const FormItem = Form.Item

class AppSettingsCompanyGeneral extends Component {
  handleSubmit = e => {
    e.preventDefault()
    const { match: { params }, form, editCompanyGeneral } = this.props

    form.validateFields((err, values) => {
      if (!err) {
        console.log(values)
        editCompanyGeneral(params.companyId, values)
      } else {
        console.log(err)
      }
    })
  }

  render () {
    const { form: { getFieldDecorator }, loading, company } = this.props

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>

          <FormItem label='Company name'>
            {getFieldDecorator('name', {
              initialValue: company && company.name,
              rules: [{ required: true }]
            })(<Input placeholder='Name of the company' />)}
          </FormItem>

          <FormItem>
            <Button htmlType='submit' type='primary' loading={loading.editCompanyGeneral}>
              Save
            </Button>
          </FormItem>

        </Form>
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading
})

const mapDispatchToProps = {
  editCompanyGeneral
}

export default connect(mapStateToProps, mapDispatchToProps)(
  Form.create()(withRouter(translate('translations')(AppSettingsCompanyGeneral)))
)



// WEBPACK FOOTER //
// ./src/components/AppSettings/AppSettingsCompanyGeneral.js